import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootStateType } from 'store'
import {
  fetchMasterAreaPickingListAPI,
  fetchMasterAreaPickingDetailAPI,
  createMasterAreaPickingAPI,
  updateMasterAreaPickingAPI,
  type UpsertMasterAreaPickingPayloadType,
  type MasterAreaPickingQueryType,
  type MasterAreaPickingDataType,
} from 'features/MasterAreaPicking/services/masterAreaPicking'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import { getLocations } from 'features/Location/services/location'
import {
  SLICE_NAME,
  setQuery,
  setIsLoading,
  setMasterAreaPickingList,
  setMasterAreaPickingDetail,
  setLocationList,
  setIsLocationLoading,
} from './masterAreaPickingSlice'

export const setQueryAction = createAsyncThunk(
  `${SLICE_NAME}/setQueryAction`,
  async (params: MasterAreaPickingQueryType, { dispatch }) => {
    try {
      dispatch(setQuery(params))
      const result = await dispatch(fetchMasterAreaPickingList())
      return result.payload
    } catch (error) {
      callErrorMsg(error)
      return false
    }
  },
)

export const fetchMasterAreaPickingList = createAsyncThunk(
  `${SLICE_NAME}/fetchMasterAreaPickingList`,
  async (_, { dispatch, getState }) => {
    try {
      dispatch(setIsLoading(true))
      const {
        masterAreaPicking: { query },
      } = getState() as RootStateType
      const { data } = await fetchMasterAreaPickingListAPI(query)
      dispatch(setMasterAreaPickingList(data))
      return data
    } catch (error) {
      callErrorMsg(error)
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  },
)

export const fetchMasterAreaPickingDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchMasterAreaPickingDetail`,
  async (id: number, { dispatch }) => {
    try {
      dispatch(setIsLoading(true))
      const { data } = await fetchMasterAreaPickingDetailAPI(id)
      dispatch(setMasterAreaPickingDetail(data?.data))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setIsLoading(false))
    }
  },
)

export const upsertMasterAreaPicking = createAsyncThunk(
  `${SLICE_NAME}/createMasterAreaPicking`,
  async (
    {
      id,
      payload,
      cb,
    }: { id: number; payload: UpsertMasterAreaPickingPayloadType; cb: () => void },
    { dispatch },
  ) => {
    try {
      dispatch(setIsLoading(true))
      if (id) {
        await updateMasterAreaPickingAPI(id, payload)
      } else {
        await createMasterAreaPickingAPI(payload)
      }
      toastSuccess(`Master Area Picking berhasil ${id ? 'diubah' : 'ditambahkan'}`)
      dispatch(setMasterAreaPickingDetail({} as MasterAreaPickingDataType))
      dispatch(fetchMasterAreaPickingList())
      cb()
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setIsLoading(false))
    }
  },
)

export const fetchLocationList = createAsyncThunk(
  `${SLICE_NAME}/fetchLocationList`,
  async ({ name }: { name: string }, { dispatch }) => {
    dispatch(setIsLocationLoading(true))
    try {
      const { data } = await getLocations({
        name: name || '',
        pageSize: 20,
      })
      dispatch(setLocationList(data.content))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setIsLocationLoading(false))
    }
  },
)
